import React from 'react';

import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';

import { breedOverviewPagesResourceDefinition } from './utils/queryDefinitions';
import BreederProfileLocationLinksGroup from './BreederProfileLocationLinksGroup';

interface BreederProfileBreedOverviewPagesProps {
  header?: string;
  limit?: number | null;
}

export default function BreederProfileBreedOverviewPages({
  header = 'Learn about similar breeds',
  limit = null
}: BreederProfileBreedOverviewPagesProps) {
  const { value: overviewPagesData, isFetching } = useResourceQuery(
    breedOverviewPagesResourceDefinition(limit)
  );

  return (
    <BreederProfileLocationLinksGroup
      linksData={overviewPagesData}
      header={header}
      wideLayout
      linkType="breed_overview"
      isFetching={isFetching}
    />
  );
}
